module.exports = __webpack_public_path__ + "img/nose.ce32754e.jpeg";